jQuery(function ($) {

  function initScentSolutionsSlider() {
    const $grid = $('.scent-solutions__grid');
    //console.log("scent solutions log")
    if (!$grid.length) return;

    if ($(window).width() <= 780) {
      if (!$grid.hasClass('slick-initialized')) {
        $grid.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
          adaptiveHeight: true,
          prevArrow: $('.scent-solutions-left-arrow'),
          nextArrow: $('.scent-solutions-right-arrow')
        });
      }
    } else {
      if ($grid.hasClass('slick-initialized')) {
        $grid.slick('unslick');
      }
    }
  }

  // Init on load
  initScentSolutionsSlider();

  // Re-init on resize
  $(window).on('resize', function () {
    initScentSolutionsSlider();
  });

});
